import { toSnakeCase, waitForAnimation } from "../../utility";
import VDialog from 'vuetify/src/components/VDialog';

export const MODAL_DEFAULT_MEDIUM = 762;
export const MODAL_DEAULT_SMALL = 400;
export const MODAL_DEFAULT_LARGE = 1200;

export const createModalMixin = (key = '', aliases = [], {
  modalQueryKey = 'modal'
} = {}) => {
  const routeKey = toSnakeCase(key);
  const matchRoutes = [routeKey, ...aliases];
  return {
    components: {
      // ModalContainer: ModalContainerComponent,
    },
    data: function () {
      return {
        [`${key}ModalContainer`]: false,
        [`${key}Modal`]: false,
      }
    },
    watch: {
      '$route': {
        immediate: true,
        handler: function (to, from) {
          // console.error(`Mixin Watch route ${key}, to.query = ${JSON.stringify(to.query)} ModalContainer = ${key}ModalContainer, modalQueryKeyValue=${to.query[modalQueryKey]}`, matchRoutes);
          // console.log(matchRoutes, to.query.modal, matchRoutes.includes(to.query.modal));
          if (to && matchRoutes.includes(to.query[modalQueryKey])) {
            if (aliases.length == 0) {
              this[`${key}ModalContainer`] = true;
              setTimeout(() => {
                this[`${key}Modal`] = true;
              }, 1);
            } else { // If 
              this[`${key}ModalContainer`] = false;
              this[`${key}Modal`] = false;

              setTimeout(() => {
                this[`${key}ModalContainer`] = true;
                setTimeout(() => {
                  this[`${key}Modal`] = true;
                }, 1);
              }, 1);
            }
          } else if (from && matchRoutes.includes(from.query[modalQueryKey]) && !matchRoutes.includes(to.query[modalQueryKey])) {
            this[`${key}Modal`] = false;
            waitForAnimation(() => {
              this[`${key}ModalContainer`] = false;
            })
          }
        }
      }
    },
  }
}

export const watchQueryModal = (modalQuery, containerKey, modalKey) => (to, from, component) => {

  // Watch and appropriately modify the flags
  if (to && to.query.modal === modalQuery) {
    component[containerKey] = true;
    waitForAnimation(() => {
      component[modalKey] = true;
    });
  } else if (from && from.query.modal === modalQuery && to.query.modal !== modalQuery) {
    component[modalKey] = false;
    waitForAnimation(() => {
      component[containerKey] = false;
    })
  }
}

export const ModalContainer = ({ props }) => {
  return (
    <div>
      {props.modalContainerFlag && <VDialog
        vModel={props.modalFlag}
        persistent={true}
        width="800"
      >
      </VDialog>}
    </div>
  );
}


export const openModalRoute = (component, modalKey, openModalQuery = {}) => {
  component.$router.push({
    ...component.$route,
    query: {
      ...component.$route.query,
      modal: modalKey,
      ...openModalQuery,
    }
  });
}

/** Open the Modal Route by Passing in the Modal Key in Camel Case */
export const openModalRoute2 = (component, modalKey, openModalQuery = {}) => {
  const modalRoute = toSnakeCase(modalKey);
  
  component.$router.push({
    ...component.$route,
    query: {
      ...component.$route.query,
      modal: modalRoute,
      ...openModalQuery,
    }
  });
}

export const closeModalRoute = (component, modalCloseQuery = {}) => {
  component.$router.push({
    ...component.$route,
    query: {
      ...Object.assign({}, component.$route.query),
      modal: undefined,
      ...modalCloseQuery
    }
  })
}


export const openModal2Route = (component, modal2Key) => {
  component.$router.push({
    ...component.$route,
    query: {
      ...component.$route.query,
      modal2: modal2Key
    }
  });
}

export const closeModal2Route = (component, modal2CloseQuery = {}) => {
  component.$router.push({
    ...component.$route,
    query: {
      ...component.$route.query,
      modal2: undefined,
      ...modal2CloseQuery
    }
  })
}